"use client";

import { c as _c } from "react/compiler-runtime";
import type { ProductCollectionSortItem, ProductSortItem } from "@repo/graphql-shopify-storefront";
import type { Usable } from "react";
import type { ResolvedIntlConfig } from "react-intl";
import { env } from "#/utilities/env";
import { useGetIntl } from "@repo/i18n/client";
import { cn } from "@repo/lib";
import { useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
import { RefineBy } from "#/components/molecules/search-refinements/refine-by";
import { RefineBySortByQueryParameterItem } from "#/components/molecules/search-refinements/refine-by-sort-by-query-parameter-item";
export function SortBy(t0) {
  const $ = _c(24);
  const {
    className,
    defaultSort,
    dictionaryPromise,
    lang,
    sortItems,
    title
  } = t0;
  let t1;
  if ($[0] !== dictionaryPromise || $[1] !== lang) {
    t1 = {
      dictionaryPromise,
      lang
    };
    $[0] = dictionaryPromise;
    $[1] = lang;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const intl = useGetIntl(t1);
  const searchParams = useSearchParams();
  let t2;
  if ($[3] !== defaultSort.title || $[4] !== searchParams || $[5] !== sortItems) {
    t2 = sortItems.find(sortItem => sortItem.slug === searchParams?.get("sort"))?.title ?? defaultSort.title;
    $[3] = defaultSort.title;
    $[4] = searchParams;
    $[5] = sortItems;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const [active, setActive] = useState(t2);
  let t3;
  let t4;
  if ($[7] !== defaultSort.title || $[8] !== searchParams || $[9] !== sortItems) {
    t3 = () => {
      const matchedSortItem = sortItems.find(sortItem_0 => sortItem_0.slug === searchParams?.get("sort"))?.title ?? defaultSort.title;
      setActive(matchedSortItem);
    };
    t4 = [defaultSort.title, searchParams, sortItems];
    $[7] = defaultSort.title;
    $[8] = searchParams;
    $[9] = sortItems;
    $[10] = t3;
    $[11] = t4;
  } else {
    t3 = $[10];
    t4 = $[11];
  }
  useEffect(t3, t4);
  let t5;
  if ($[12] !== className) {
    t5 = cn({
      hidden: env.NEXT_PUBLIC_FEATURE_FLAG_SEARCH_COLLECTIONS_ENABLE !== true
    }, className);
    $[12] = className;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== intl || $[15] !== title) {
    t6 = title ?? intl.formatMessage({
      defaultMessage: "Sort by",
      description: "Title for sort by section",
      id: "sb2U9s"
    });
    $[14] = intl;
    $[15] = title;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== sortItems) {
    t7 = sortItems.map(_temp);
    $[17] = sortItems;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== active || $[20] !== t5 || $[21] !== t6 || $[22] !== t7) {
    t8 = <RefineBy active={active} className={t5} title={t6}>{t7}</RefineBy>;
    $[19] = active;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
}
function _temp(item) {
  return <RefineBySortByQueryParameterItem key={item.title} item={item} />;
}